import i18n from '@/utils/i18n';
import React, { useMemo } from 'react';
import { CategoryProps, GTINFilterCategories } from './gtin-filter-categories';
import { CollapsableFilters } from './collapsable-filters';
import { CollapsableGTINFilterList } from './collapsable-gtin-filter-list';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { GTINFilterCheckbox } from './gtin-filter-checkbox';
import {
  GTINFilterItemGroupCategories,
  ItemGroupCategoryProps,
} from './gtin-filter-item-group-categories';
import { GTINFilters } from '@/hooks/use-gtin-metadata-filters';
import { ScrollView, Text, TouchableOpacity } from 'react-native';

interface BaseProps {
  gtinFilters: GTINFilters;
}

type Props = BaseProps | (BaseProps & (CategoryProps | ItemGroupCategoryProps));

export const GTINFilterSidePanel: React.FC<Props> = ({
  gtinFilters,
  ...props
}) => {
  const [styles] = useStyles();
  const [listFiltersToRender, flagFiltersToRender] = useMemo(() => {
    const listFilters = gtinFilters.listFilters.filter(
      (filter) => filter.isAvailable,
    );
    const flagFilters = gtinFilters.flagFilters.filter(
      (filter) => filter.isAvailable,
    );
    return [listFilters, flagFilters];
  }, [gtinFilters]);

  return (
    <ScrollView alwaysBounceVertical={false}>
      {'categories' in props ? <GTINFilterCategories {...props} /> : null}
      {'itemGroupCategories' in props ? (
        <GTINFilterItemGroupCategories {...props} />
      ) : null}
      {listFiltersToRender.map((filter) => (
        <CollapsableGTINFilterList key={filter.label} listFilter={filter} />
      ))}
      {flagFiltersToRender.map((filter) => (
        <TouchableOpacity
          key={filter.label}
          onPress={() => filter.updateFilter((prev) => !prev)}
          style={styles.flagFilter}
        >
          <GTINFilterCheckbox
            isSelected={filter.filterApplied}
            onSelect={() => filter.updateFilter((prev) => !prev)}
          />
          <Text style={[TYPOGRAPHY.medium, FONTS.primarySemiBold]}>
            {filter.label}
          </Text>
        </TouchableOpacity>
      ))}
      {'itemGroupCategories' in props && Boolean(props.badges?.length) ? (
        <CollapsableFilters
          label={i18n.t('badges')}
          onSelect={props.onSelectBadges}
          options={props.badges.map((b) => ({
            title: b.name,
            value: b.uuid,
          }))}
          selected={props.badgesFilter}
        />
      ) : null}
    </ScrollView>
  );
};

const useStyles = createStyles((theme) => ({
  flagFilter: {
    alignItems: 'center',
    borderBottomColor: theme.colors.stroke,
    borderBottomWidth: 1,
    flexDirection: 'row',
    gap: 16,
    justifyContent: 'space-between',
    paddingVertical: 16,
  },
}));
